export const USE_EXPERIMENT_COMPANY_MAIN_BENEFITS_VARIATION = 2;
